/* Comportements de l'en-tete : recherche, panier, menu mobile.
   Reprend le script de la maquette, moins ce qui y etait factice :
   - plus d'appel a Lucide (les icones sont des SVG inlines) ;
   - plus de faux formulaire newsletter (c'est le formulaire Shopify qui repond).
   Chaque element est optionnel : si l'un manque, le reste continue de marcher. */
(function () {
  var $ = function (s) { return document.querySelector(s); };

  var panierOverlay = $('#cartOverlay');
  var panneauRecherche = $('#searchPanel');
  var panneauMobile = $('#mobilePanel');

  function basculer(el, ouvert) {
    if (!el) return;
    el.classList.toggle('open', ouvert);
    el.setAttribute('aria-hidden', String(!ouvert));
    document.body.style.overflow = ouvert ? 'hidden' : '';
  }

  function brancher(selecteur, evenement, action) {
    var el = $(selecteur);
    if (el) el.addEventListener(evenement, action);
  }

  /* Panier : on ouvre le tiroir, et on laisse le lien vers /cart faire son
     travail si le JS n'a pas pu se charger. */
  brancher('.cart', 'click', function (e) {
    if (!panierOverlay) return;
    e.preventDefault();
    basculer(panierOverlay, true);
  });
  brancher('.close-cart', 'click', function () { basculer(panierOverlay, false); });
  if (panierOverlay) {
    panierOverlay.addEventListener('click', function (e) {
      if (e.target === panierOverlay) basculer(panierOverlay, false);
    });
  }

  brancher('.search-trigger', 'click', function () {
    if (!panneauRecherche) return;
    panneauRecherche.classList.add('open');
    this.setAttribute('aria-expanded', 'true');
    var champ = $('#searchInput');
    if (champ) champ.focus();
  });
  brancher('.close-search', 'click', function () {
    if (!panneauRecherche) return;
    panneauRecherche.classList.remove('open');
    var d = $('.search-trigger');
    if (d) d.setAttribute('aria-expanded', 'false');
  });

  brancher('.mobile-menu-button', 'click', function () {
    basculer(panneauMobile, true);
    this.setAttribute('aria-expanded', 'true');
  });
  brancher('.close-menu', 'click', function () {
    basculer(panneauMobile, false);
    var d = $('.mobile-menu-button');
    if (d) d.setAttribute('aria-expanded', 'false');
  });
  if (panneauMobile) {
    panneauMobile.querySelectorAll('a').forEach(function (l) {
      l.addEventListener('click', function () { basculer(panneauMobile, false); });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    basculer(panierOverlay, false);
    basculer(panneauMobile, false);
    if (panneauRecherche) panneauRecherche.classList.remove('open');
  });
})();

/* --- Fiche produit ------------------------------------------------------
   Galerie (vignettes, fleches, compteur), quantite, variante, accordeons,
   barre d'achat sur telephone. Classes reprises de la maquette.
   Tout est optionnel : sur une page sans fiche produit, rien ne s'execute. */
(function () {
  var fiche = document.querySelector(".product-section");
  if (!fiche) return;

  /* --- Galerie --- */
  var vues = [].slice.call(fiche.querySelectorAll(".thumb"));
  var grande = fiche.querySelector("#mainProductImage");
  var compteur = fiche.querySelector("#galleryIndex");
  var courante = 0;

  function montrer(i) {
    if (!vues.length || !grande) return;
    courante = (i + vues.length) % vues.length;
    var v = vues[courante];
    /* On prend l'adresse HAUTE DEFINITION portee par la vignette, jamais
       l'image de la vignette elle-meme : celle-ci ne fait que 200 px et,
       etiree sur toute la zone, elle donne une photo floue. */
    grande.src = v.dataset.image;
    grande.srcset = "";
    if (v.dataset.alt) grande.alt = v.dataset.alt;
    vues.forEach(function (o, n) { o.classList.toggle("active", n === courante); });
    if (compteur) compteur.textContent = courante + 1;
  }
  vues.forEach(function (v, i) { v.addEventListener("click", function () { montrer(i); }); });

  var precedente = fiche.querySelector(".gallery-prev");
  var suivante = fiche.querySelector(".gallery-next");
  if (precedente) precedente.addEventListener("click", function () { montrer(courante - 1); });
  if (suivante) suivante.addEventListener("click", function () { montrer(courante + 1); });

  /* --- Quantite : l'affichage et la valeur envoyee doivent rester d'accord --- */
  var vue = fiche.querySelector("#quantity");
  var champ = fiche.querySelector('input[name="quantity"]');
  fiche.querySelectorAll("[data-qte]").forEach(function (b) {
    b.addEventListener("click", function () {
      var n = parseInt(vue ? vue.textContent : "1", 10) || 1;
      n = Math.max(1, b.dataset.qte === "+" ? n + 1 : n - 1);
      if (vue) vue.textContent = n;
      if (champ) champ.value = n;
    });
  });

  /* --- Le prix affiche doit suivre la variante choisie, sinon il ment. --- */
  var select = fiche.querySelector("[data-variantes]");
  if (select) {
    select.addEventListener("change", function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      /* ⚠ Le prix de l'option est lu dans `data-prix-variante`, PAS `data-prix`.
         Avec le meme nom des deux cotes, `querySelectorAll("[data-prix]")`
         attrapait les OPTIONS elles-memes et remplacait « Noir », « Rouge »...
         par le prix : le menu devenait une liste de quatre fois « 22,77 € ». */
      if (opt.dataset.prixVariante) {
        document.querySelectorAll("[data-prix]").forEach(function (e) {
          e.innerHTML = opt.dataset.prixVariante;
        });
      }
      /* La photo doit suivre la couleur choisie : sans cela, on selectionne
         « Rose » et l'ecran continue de montrer l'appareil noir. On aligne
         aussi la vignette active, sinon la galerie et le choix se contredisent. */
      if (opt.dataset.image && grande) {
        grande.src = opt.dataset.image;
        grande.srcset = "";
        if (opt.dataset.alt) grande.alt = opt.dataset.alt;
        var cible = vues.findIndex(function (v) { return v.dataset.image === opt.dataset.image; });
        if (cible >= 0) {
          courante = cible;
          vues.forEach(function (o, n) { o.classList.toggle("active", n === cible); });
          if (compteur) compteur.textContent = cible + 1;
        }
      }
    });
  }

  /* --- Accordeons --------------------------------------------------------
     La feuille de la maquette fait toute l'animation (grid-template-rows de
     0fr a 1fr) et attend la classe « open » sur l'element. On se contente donc
     de poser cette classe : rien a calculer ici, et surtout pas une hauteur.
     (Premiere version : je posais « active » et je manipulais max-height, que
     ce CSS n'utilise pas — l'accordeon changeait d'etat sans jamais s'ouvrir.) */
  fiche.querySelectorAll(".accordion-toggle").forEach(function (b) {
    b.addEventListener("click", function () {
      var ouvert = b.getAttribute("aria-expanded") === "true";
      b.setAttribute("aria-expanded", ouvert ? "false" : "true");
      b.parentElement.classList.toggle("open", !ouvert);
    });
  });

  /* --- Barre d'achat sur telephone : elle relaie vers le vrai bouton, elle
         ne refait pas la mecanique d'ajout au panier. --- */
  var barre = document.querySelector(".mobile-buy");
  var panneau = fiche.querySelector(".buy-panel");
  if (barre && panneau && "IntersectionObserver" in window) {
    /* La feuille de la maquette attend « show » sur cette barre, pas « active ». */
    new IntersectionObserver(function (entrees) {
      barre.classList.toggle("show", !entrees[0].isIntersecting);
    }, { rootMargin: "-90px 0px 0px 0px" }).observe(panneau);

    var relais = barre.querySelector("[data-vers-achat]");
    var vrai = fiche.querySelector(".add-cart");
    if (relais && vrai) relais.addEventListener("click", function () { vrai.click(); });
  }
})();

/* --- Carrousel des blocs categorie (mise en page A) ----------------------
   Repris du script de la maquette, avec trois corrections :

   - la maquette figeait le nombre de produits a SIX (compteur plafonne a 6,
     barre de progression a 16,7 % = 100/6). Une collection de 7 ou 15 produits
     aurait affiche « 06 / 06 » en plein milieu et une barre fausse. Le nombre
     vient maintenant du serveur, via data-total ;
   - l'espacement entre cartes etait ecrit en dur (13 px) : il est lu dans le
     style calcule, donc il suit le CSS si la maquette evolue ;
   - la page d'accueil porte DEUX blocs : on boucle sur les instances au lieu
     de viser des identifiants uniques.

   Sans JavaScript, la piste reste defilable au doigt et a la molette : les
   fleches sont un confort, pas le seul moyen d'atteindre les produits. */
(function () {
  document.querySelectorAll("[data-carrousel]").forEach(function (bloc) {
    var piste = bloc.querySelector("[data-piste]");
    var precedent = bloc.querySelector(".prev");
    var suivant = bloc.querySelector(".next");
    var position = bloc.querySelector("[data-position]");
    var barre = bloc.querySelector("[data-progression]");
    if (!piste || !piste.children.length) return;

    var total = parseInt(bloc.dataset.total, 10) || piste.children.length;
    var part = 100 / total;              // ce qu'une carte occupe de la barre

    function pas() {
      var carte = piste.querySelector(".card");
      var ecart = parseFloat(getComputedStyle(piste).columnGap || 0) || 0;
      return carte ? carte.getBoundingClientRect().width + ecart : 0;
    }

    function actualiser() {
      var max = piste.scrollWidth - piste.clientWidth;
      if (precedent) precedent.disabled = piste.scrollLeft < 4;
      if (suivant) suivant.disabled = piste.scrollLeft > max - 4;

      var largeur = pas();
      var n = largeur ? Math.round(piste.scrollLeft / largeur) + 1 : 1;
      n = Math.min(total, Math.max(1, n));
      if (position) position.textContent = String(n).padStart(2, "0");

      // max vaut 0 quand tout tient a l'ecran : la barre est alors pleine,
      // et surtout on ne divise pas par zero (ce qui donnerait NaN%).
      if (barre) {
        var avance = max > 0 ? (piste.scrollLeft / max) * (100 - part) : 100 - part;
        barre.style.width = Math.min(100, avance + part) + "%";
      }
    }

    if (precedent) precedent.onclick = function () { piste.scrollBy({ left: -pas(), behavior: "smooth" }); };
    if (suivant) suivant.onclick = function () { piste.scrollBy({ left: pas(), behavior: "smooth" }); };
    piste.addEventListener("scroll", actualiser, { passive: true });
    addEventListener("resize", actualiser);
    actualiser();
  });
})();

/* --- Bloc editorial repliable -------------------------------------------
   Le repli est pose PAR LE JS : sans JS, le texte reste entierement visible.
   Et si le texte est court, aucun bouton n'apparait. */
(function () {
  document.querySelectorAll("[data-seo]").forEach(function (bloc) {
    var corps = bloc.querySelector(".bloc-seo-corps");
    var bouton = bloc.querySelector("[data-seo-bouton]");
    if (!corps || !bouton) return;
    if (corps.scrollHeight <= 300) return;      // texte court : rien a replier
    bloc.setAttribute("data-replie", "");
    bouton.hidden = false;
    bouton.addEventListener("click", function () {
      var replie = bloc.hasAttribute("data-replie");
      if (replie) bloc.removeAttribute("data-replie");
      else bloc.setAttribute("data-replie", "");
      bouton.querySelector("span").textContent = replie ? "Réduire" : "Lire la suite";
    });
  });
})();

/* --- « Voir plus » : reveler sans pagination ----------------------------
   Tous les articles/produits sont dans le HTML (crawlables). On en masque une
   partie en CSS ; le bouton les revele en ajoutant la classe `tout`. Aucune URL
   ?page=, aucun fetch : zero pagination pour les moteurs. */
(function () {
  document.querySelectorAll("[data-voir-plus]").forEach(function (btn) {
    var wrap = btn.closest(".ta-blog, .ta-cate-v2, section") || document.body;
    var grille = wrap.querySelector("[data-limite]");
    if (!grille) return;
    btn.addEventListener("click", function () {
      grille.classList.add("tout");
      var box = btn.closest(".charger-plus");
      if (box) box.remove();
    });
  });
})();

/* --- Recommandations produit -------------------------------------------
   Shopify ne calcule les recommandations qu'a la demande : au premier rendu le
   bloc est vide, on recharge la section a l'adresse qu'elle porte. Si Shopify
   ne renvoie rien, on ne laisse rien : aucun produit mis la pour meubler. */
(function () {
  var bloc = document.querySelector("[data-reco]");
  if (!bloc || !bloc.dataset.url) return;
  fetch(bloc.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var recu = new DOMParser().parseFromString(html, "text/html").querySelector("[data-reco]");
      if (recu && recu.innerHTML.trim()) bloc.innerHTML = recu.innerHTML;
    })
    .catch(function () { /* pas de recommandation : le bloc reste vide */ });
})();
